/* eslint-disable sonarjs/no-identical-functions */
import styled from '@emotion/styled';
import React from 'react';
import { animated, useSpring } from 'react-spring';

interface IProps {
  isOpen: boolean;
  isHover: boolean;
}

const Div = styled.div`
  height: 40px;
  width: 40px;
  min-height: 40px;
  min-width: 40px;
  position: relative;
`;

const PlusLine = styled(animated.line)<{ isHover: boolean; isOpen: boolean }>`
  shape-rendering: crispedges;

  transform-origin: 50% 50%;
  transform: rotate(0deg);
  opacity: 1;
  ${(props) =>
    props.isHover || props.isOpen
      ? 'stroke:rgb(255,255,255)'
      : 'stroke:rgb(30,60,90)'};
`;
const MinusLine = styled(animated.line)<{ isHover: boolean; isOpen: boolean }>`
  shape-rendering: crispedges;

  transform-origin: 50% 50%;
  transform: rotate(0deg);

  ${(props) =>
    props.isHover || props.isOpen
      ? 'stroke:rgb(255,255,255)'
      : 'stroke:rgb(30,60,90)'};
`;
const Box = styled.rect<{ isOpen: boolean; isHover: boolean }>`
  transition: all 0.4s linear;
  ${(props) =>
    props.isHover || props.isOpen
      ? 'fill:rgb(30,60,90)'
      : 'fill:rgb(255,255,255)'};
`;

export const ButtonPlus = ({ isOpen, isHover }: IProps) => {
  const PlusLineRotate = useSpring({
    transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
    config: { mass: 10, tension: 2000, friction: 200, duration: 300 },
  });

  const MinusLineRotate = useSpring({
    opacity: isOpen ? 0 : 1,
    transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
    config: { mass: 10, tension: 2000, friction: 200, duration: 300 },
  });

  return (
    <Div>
      <svg id="e2kt2k1630ka1" viewBox="0 0 40 40">
        <g id="e2kt2k1630ka2">
          <path
            id="e2kt2k1630ka3"
            d="M39,1L39,39L1,39L1,1L39,1M40,0L0,0L0,40L40,40L40,0Z"
            fill="rgb(30,60,90)"
            stroke="none"
            strokeWidth="1"
          />
        </g>
        <g id="e2kt2k1630ka4">
          <line
            id="e2kt2k1630ka5"
            x1="20"
            y1="13.500000"
            x2="20"
            y2="26.500000"
            fill="none"
            stroke="rgb(30,60,90)"
            strokeWidth="1"
            strokeMiterlimit="10"
          />
        </g>
        <g id="e2kt2k1630ka6">
          <line
            id="e2kt2k1630ka7"
            x1="26.500000"
            y1="20"
            x2="13.500000"
            y2="20"
            fill="none"
            stroke="rgb(30,60,90)"
            strokeWidth="1"
            strokeMiterlimit="10"
          />
        </g>
        <g id="e2kt2k1630ka8">
          <Box
            isOpen={isOpen}
            isHover={isHover}
            id="e2kt2k1630ka9"
            width="39"
            height="39"
            rx="0"
            ry="0"
            transform="matrix(1 0 0 1 0.50000000000000 0.50000000000000)"
            stroke="none"
            strokeWidth="1"
            strokeOpacity="0"
          />
          <path
            id="e2kt2k1630ka10"
            d="M39,1L39,39L1,39L1,1L39,1M40,0L0,0L0,40L40,40L40,0Z"
            fill="rgb(30,60,90)"
            stroke="none"
            strokeWidth="1"
          />
        </g>
        <g id="e2kt2k1630ka11" opacity="0">
          <line
            id="e2kt2k1630ka12"
            x1="26.500000"
            y1="20"
            x2="13.500000"
            y2="20"
            fill="none"
            stroke="rgb(30,60,90)"
            strokeWidth="1"
            strokeMiterlimit="10"
          />
        </g>
        <MinusLine
          id="e2kt2k1630ka13"
          x1="20"
          y1="13.500000"
          x2="20"
          y2="26.500000"
          fill="none"
          stroke="rgb(30,60,90)"
          strokeWidth="1"
          strokeMiterlimit="10"
          style={{ ...MinusLineRotate } as any}
          isHover={isHover}
          isOpen={isOpen}
        />
        <PlusLine
          id="e2kt2k1630ka14"
          x1="26.500000"
          y1="20"
          x2="13.500000"
          y2="20"
          fill="none"
          stroke="rgb(30,60,90)"
          strokeWidth="1"
          strokeMiterlimit="10"
          style={{ ...PlusLineRotate } as any}
          isHover={isHover}
          isOpen={isOpen}
        />
      </svg>
    </Div>
  );
};
